import React from 'react'
import { useHistory } from 'react-router-dom'

import ViewOnlySIFormProperties from './ViewOnlySIFormProperties'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/PathMap_ShippingInstruction'

const {
  form: { CngViewForm }
} = components

function ViewOnlySIPage({ showNotification }) {
  const history = useHistory()


  function onSubmit(data) {
    console.log('submit', data)


    history.push('/');
    history.replace({ pathname: pathMap.VIEW_ONLY_SI, state: data })
  }

  return (

    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <ViewOnlySIFormProperties.FormFields
          disabled={false}
          isViewSi={true}
          showNotification={showNotification}
        />
      }
      formikProps={{
        ...ViewOnlySIFormProperties.formikProps,
        onSubmit: onSubmit
      }}
    />

  )
}

export default ViewOnlySIPage
